<template>
  <section id="register" class="checkout-section">
    <div class="container">
      <div class="checkout-content">
        <div class="row">
          <div class="col-md-9" id="main">
            <div class="order-payment">
              <div class="section-title-2  headline text-left">
                <h2>注册<span>信息</span></h2>
              </div>
              <div class="payment-method">
                <el-form :model="model" status-icon :rules="rules" ref="ruleForm" label-width="190px" class="check-out-form">
                  <el-form-item label="企业名称：" prop="Name">
                    <el-input type="text" class="payment-info" placeholder="" v-model.trim="model.Name"></el-input>
                  </el-form-item>
                  <el-form-item label="统一社会信用代码：" prop="Uscc">
                    <el-input type="text" class="payment-info" placeholder="" v-model.trim="model.Uscc"></el-input>
                  </el-form-item>
                  <el-form-item label="企业地址：" prop="Address">
                    <el-input type="text" class="payment-info " placeholder="" v-model.trim="model.Address"></el-input>
                  </el-form-item>
                  <el-form-item label="企业负责人：" prop="Principal">
                    <el-input type="text" class="payment-info" placeholder="" v-model.trim="model.Principal"></el-input>
                  </el-form-item>
                  <el-form-item label="负责人联系电话：" prop="PrincipalMobile">
                    <el-input type="text" class="payment-info" placeholder="" v-model.trim="model.PrincipalMobile"></el-input>
                  </el-form-item>
                  <el-form-item label="营业执照扫描件：" prop="BusinessLicense" id="form-BusinessLicense">
                    <div style="display:flex;">
                      <div style="width: 318px; height: 226px;margin-bottom:10px;">
                        <div class="avatar-uploader" onclick="file.click()">
                          <i v-show="model.BusinessLicense==null" class="el-icon-plus avatar-uploader-icon"></i>
                          <input type="file" name="file" id='file' class="el-upload__input" multiple accept="image/jpeg,image/jpg" @change="handleAvatarSuccess">
                          <div class="avatar-title">上传营业执照扫描件</div>
                        </div>
                        <k-btn-img v-show="model.BusinessLicense!=null" :slides="model" style="width: 318px; height: 226px;">
                          <template slot="img" slot-scope="scope1">
                            <img id="img_1" :src="scope1.item.BusinessLicense" style="width: 100%; height: 100%; object-fit: cover;">
                          </template>
                          <template slot="btn" slot-scope="scope2">
                            <div style="width:80px;flex: none;" @click="onClickImg('img_1')">查看大图</div>
                            <div style="width:80px;flex: none;" onclick="file.click()">重新上传</div>
                          </template>
                        </k-btn-img>
                      </div>
                      <div style="color:#CCCCCC;font-size:14px;margin-left:16px;line-height:20px;">
                        营业执照扫描件为 jpg 格式，大小不得超过 2MB，并且文字清晰
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item v-if="enableEnterprisZz == true" label="主营业务：" required>
                    <el-col :span="8">
                      <el-form-item prop="QualificationSequence">
                        <el-select v-model="model.QualificationSequenceId" placeholder="" @change="changeZzxls">
                          <el-option v-for="item in enterpriseZzxls" :label="item.name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1" style="text-align:center">-</el-col>
                    <el-col :span="7">
                      <el-form-item prop="Qualification">
                        <el-select v-model="model.QualificationId" placeholder="" @change="changeQyzzs">
                          <el-option v-for="item in enterpriseQyzzs" :label="item.name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1" style="text-align:center">-</el-col>
                    <el-col :span="7">
                      <el-form-item prop="QualificationLevel">
                        <el-select v-model="model.QualificationLevel" placeholder="">
                          <el-option v-for="item in enterpriseLevels" :label="item.name" :value="item.name" :key="item.name"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <el-form-item v-if="enableEnterprisZz == true" label="主营业务资质扫描件：" prop="PicZzzm" id="form-PicZzzm">
                    <div style="display:flex;">
                      <div style="width: 318px; height: 226px;margin-bottom:10px;">
                        <div class="avatar-uploader" onclick="zzzmFile.click()">
                          <i v-show="model.PicZzzm==null" class="el-icon-plus avatar-uploader-icon"></i>
                          <input type="file" name="zzzmFile" id='zzzmFile' class="el-upload__input" multiple accept="image/jpeg,image/jpg" @change="handleZzzmSuccess">
                          <div class="avatar-title">主营业务资质扫描件</div>
                        </div>
                        <k-btn-img v-show="model.PicZzzm!=null" :slides="model" style="width: 318px; height: 226px;">
                          <template slot="img" slot-scope="scope1">
                            <img id="img_zzzm" :src="scope1.item.PicZzzm" style="width: 100%; height: 100%; object-fit: cover;">
                          </template>
                          <template slot="btn" slot-scope="scope2">
                            <div style="width:80px;flex: none;" @click="onClickImg('img_zzzm')">查看大图</div>
                            <div style="width:80px;flex: none;" onclick="zzzmFile.click()">重新上传</div>
                          </template>
                        </k-btn-img>
                      </div>
                      <div style="color:#CCCCCC;font-size:14px;margin-left:16px;line-height:20px;">
                        主营业务资质扫描件为 jpg 格式，大小不得超过 2MB，并且文字清晰
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="联系人：" prop="Contact">
                    <el-input type="text" class="payment-info" placeholder="" v-model.trim="model.Contact"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号：" prop="Mobile">
                    <el-input type="text" class="payment-info" placeholder="" v-model.trim="model.Mobile"></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="验证码：" prop="VerifyCode" id='verifyCode'>
                    <div class="input-3">
                      <el-input type="text" class="payment-info" placeholder="" v-model.trim="model.VerifyCode"></el-input>
                      <div id="TencentCaptchaZC">
                        <a :class="timerNub==0?'link' : 'disabled' ">
                          <span v-if="timerNub!=0">( {{timerNub}} )</span>
                          <span v-else-if="timerNub==0">获取验证码</span>
                        </a>
                      </div>
                    </div>
                  </el-form-item> -->
                  <el-form-item v-if="enableEnterpriseEmail == true" label="电子邮箱：" prop="Email" style="position: relative;">
                    <el-input type="text" class="payment-info" placeholder="*用于接收电子发票" v-model.trim="model.Email"></el-input>
                  </el-form-item>
                  <el-form-item v-if="enableEnterpriseEmail == true" label="确认电子邮箱：" prop="RegistrationEmail" style="position: relative;">
                    <el-input type="text" class="payment-info" v-model.trim="model.RegistrationEmail"></el-input>
                  </el-form-item>
                  <el-form-item label="登录密码：" prop="Password">
                    <el-input :type="inputType" autocomplete="new-password" class="payment-info" @focus="changePasswordinput" placeholder="" v-model.trim="model.Password"></el-input>
                  </el-form-item>
                  <el-form-item label="确认密码：" prop="RegistrationPassword">
                    <el-input :type="inputType" class="payment-info" placeholder="" v-model.trim="model.RegistrationPassword"></el-input>
                  </el-form-item>
                </el-form>
                <!-- <div class="method-header-text">
                    <div class="checkbox save-credit">
                      <label>
                        <input type="checkbox" v-model="xyCheckbox">
                        <span class="cr text-uppercase bold-font"><i class="cr-icon fa fa-check"></i></span>
                        <span class="sub-text">我已阅读并认可<b>《用户使用协议》</b></span>
                      </label>
                    </div>
                  </div> -->
              </div>
              <div class="mt25">
                <el-button class="k-btn normal" @click="onSubmit">注 册</el-button>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <component :is="newsView" ref="newsView"></component>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Vue, ProjectSettings } from '../base/base.js';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
let viewer = null;

export default {
  name: 'register',
  data: function () {
    let validateEmail = (rule, value, callback) => {
      if (Utils.checkEmail(value) === false) {
        callback(new Error('请输入正确的电子邮箱'));
      } else {
        callback();
      }
    };
    let validateEmail2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入电子邮箱'));
      } else if (value !== this.model.Email) {
        callback(new Error('两次输入电子邮箱不一致!'));
      } else {
        callback();
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度至少6位'));
      } else {
        if (this.model.RegistrationPassword !== '') {
          this.$refs.ruleForm.validateField('RegistrationPassword');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.model.Password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (Utils.checkPhone(value) === false) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    return {
      model: {
        Name: null,
        Address: null,
        Principal: null,
        PrincipalMobile: null,
        Uscc: null,
        Contact: null,
        Email: null,
        RegistrationEmail: null,
        Mobile: null,
        VerifyCode: null,
        Password: '',
        RegistrationPassword: '',
        BusinessLicense: null,
        QualificationSequenceId: null,
        QualificationId: null,
        QualificationSequence: null,
        Qualification: null,
        QualificationLevel: null,
        PicZzzm: null
      },
      rules: {
        Name: [
          { required: true, message: '请填写企业名称', trigger: ['blur', 'change'] }
        ],
        Address: [
          { required: true, message: '请填写企业地址', trigger: ['blur', 'change'] }
        ],
        Principal: [
          { required: true, message: '请填写企业负责人', trigger: ['blur', 'change'] }
        ],
        PrincipalMobile: [
          { required: true, message: '请填写负责人联系电话', trigger: ['blur', 'change'] },
          { validator: checkPhone, trigger: ['blur', 'change'] }
        ],
        BusinessLicense: [
          { required: true, message: '请上传营业执照扫描件', trigger: ['blur', 'change'] }
        ],
        PicZzzm: [
          { required: true, message: '请上传资质证明扫描件', trigger: ['blur', 'change'] }
        ],
        QualificationSequence: [
          { required: true, message: '请选择资质类别', trigger: ['blur', 'change'] }
        ],
        Qualification: [
          { required: true, message: '请选择企业主项资质', trigger: ['blur', 'change'] }
        ],
        QualificationLevel: [
          { required: true, message: '请选择等级', trigger: ['blur', 'change'] }
        ],
        Uscc: [
          { required: true, message: '请填写统一社会信用代码', trigger: ['blur', 'change'] }
        ],
        Contact: [
          { required: true, message: '请填写企业联系人', trigger: ['blur', 'change'] }
        ],
        Mobile: [
          { required: true, message: '请填写企业联系电话', trigger: ['blur', 'change'] },
          { validator: checkPhone, trigger: ['blur', 'change'] }
        ],
        VerifyCode: [
          { required: true, message: '请填写验证码', trigger: ['blur', 'change'] }
        ],
        Email: [
          { required: true, message: '请填写电子邮箱', trigger: ['blur', 'change'] },
          { validator: validateEmail, trigger: ['blur', 'change'] }
        ],
        RegistrationEmail: [
          { required: true, validator: validateEmail2, trigger: ['blur', 'change'] }
        ],
        Password: [
          { required: true, validator: validatePass, trigger: ['blur', 'change'] }
        ],
        RegistrationPassword: [
          { required: true, validator: validatePass2, trigger: ['blur', 'change'] }
        ],
        ErrorMessages: ''
      },
      timerNub: 0,
      xyCheckbox: false,
      enableEnterpriseEmail: ProjectSettings.EnableEnterpriseEmail,
      enableEnterprisZz: ProjectSettings.EnableEnterprisZz,
      inputType: 'text',
      enterpriseZzxls: [],
      enterpriseQyzzs: [],
      enterpriseLevels: []
    }
  },
  created: function () {
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./new/list'], resolve)
    });
  },
  mounted: function () {
    viewer = null;
    let that = this;
    // let captcha = new TencentCaptcha(document.getElementById('TencentCaptchaZC'),
    //   '2049138413',
    //   function (res) {
    //     let obj = {};
    //     if (res.ret === 0) {
    //       obj = {
    //         Ticket: res.ticket,
    //         Randstr: res.randstr,
    //         mobile: that.model.Mobile
    //       }

    //       that.postSendverifyCode(obj);
    //     }
    //   },
    //   { bizState: '自定义透传参数' }
    // );
    // console.log(captcha);

    Utils.getEnterpriseQualifications()
      .then(function (res) {
        console.log(res)
        that.enterpriseZzxls = res
      })
      .catch(err => { console.log(err) }
      );
  },
  methods: {
    onSubmit() {
      let that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch('getEnterpriseRegistration', this.model).then((response) => {
            if (response.MsgCode === 0) {
              this.$alert(response.Message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  that.$router.push({ name: 'index' });
                }
              });
              this.model = {
                Name: null,
                Address: null,
                Principal: null,
                PrincipalMobile: null,
                Uscc: null,
                Contact: null,
                Email: null,
                RegistrationEmail: null,
                Mobile: null,
                VerifyCode: null,
                Password: '',
                RegistrationPassword: '',
                BusinessLicense: null,
                QualificationSequenceId: null,
                QualificationId: null,
                QualificationSequence: null,
                Qualification: null,
                QualificationLevel: null,
                PicZzzm: null
              };
            } else {
              this.$alert(response.Message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    postSendverifyCode(obj) {
      // 如果手机号码不能通过验证
      if (Utils.checkPhone(this.model.Mobile) === false) {
        this.$alert('请输入正确的手机号！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }

      if (this.timerNub !== 0) {
        return;
      }
      let that = this;
      let maxtime = 60;
      this.timerNub = maxtime;
      this.$store.dispatch('postSendverifyCode', obj).then((response) => {
        if (response.Data.MsgCode === 1) {
          this.$alert(response.Data[0].ErrorMessages[0], '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      });

      let timer = window.setInterval(() => {
        maxtime--;
        that.timerNub = maxtime;
        if (maxtime <= 0) {
          that.timerNub = 0;
          window.clearInterval(timer);
        }
      }, 1000);
    },
    handleAvatarSuccess(ev, row) {
      let that = this;
      const rawFile = ev.target.files[0];
      if (!rawFile) return;

      this.beforeImageUpload(rawFile);
      try {
        let image = new Image();
        image.src = window.URL.createObjectURL(rawFile);
        image.onload = function () {
          let obj = { Prefix: rawFile.type, File: rawFile };
          that.$store.dispatch('postUploadPic', obj).then((res) => {
            that.model.BusinessLicense = res.Data;
          });
        };
      } catch (err) {
        console.error(err);
      }
    },
    handleZzzmSuccess(ev, row) {
      let that = this;
      const rawFile = ev.target.files[0];
      if (!rawFile) return;

      this.beforeImageUpload(rawFile);
      try {
        let image = new Image();
        image.src = window.URL.createObjectURL(rawFile);
        image.onload = function () {
          let obj = { Prefix: rawFile.type, File: rawFile };
          that.$store.dispatch('postUploadPic', obj).then((res) => {
            that.model.PicZzzm = res.Data;
          });
        };
      } catch (err) {
        console.error(err);
      }
    },
    beforeImageUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$alert('上传的图片限制为 jpg 格式!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        // this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$alert('上传的图片大小不能超过 2MB!', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        // this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    onClickImg(id) {
      if (viewer == null) {
        // 初始化 viewer.js
        viewer = new Viewer(document.getElementById('main'));
      }
      viewer.update();
      $('#' + id).click();
    },
    cnsUpdate(id) {
      $('#' + id).click();
    },
    changePasswordinput() {
      this.inputType = 'password';
    },
    changeZzxls(val) {
      this.enterpriseQyzzs = [];
      this.enterpriseLevels = [];
      this.model.QualificationSequence = null;
      this.model.QualificationId = null;
      this.model.Qualification = null;
      this.model.QualificationLevel = null;

      if (val) {
        let obj = _.find(this.enterpriseZzxls, { 'id': val });
        if (obj) {
          this.model.QualificationSequence = obj.name;
          this.enterpriseQyzzs = obj.list;
        }
      }
    },
    changeQyzzs(val) {
      this.enterpriseLevels = [];
      this.model.Qualification = null;
      this.model.QualificationLevel = null;

      if (val) {
        let obj = _.find(this.enterpriseQyzzs, { 'id': val });
        if (obj) {
          this.model.Qualification = obj.name;
          this.enterpriseLevels = obj.list;
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.payment-info {
  // width: 614px;
  // display: flex;
  input {
    flex: 1;
  }
  a {
    width: 90px;
    line-height: 48px;
    color: #17d0cf !important;
    cursor: pointer;
    text-align: right;
    display: flex;
    justify-content: center;
    &.disabled {
      color: #9fabab !important;
      cursor: not-allowed;
    }
  }
}
.input-3 {
  display: flex;
  .payment-info {
    width: 520px;
    margin-right: 16px;
  }
  .link {
    text-align: right;
    font-size: 14px;
    color: #16cfd0;
    cursor: pointer;
  }
  .disabled {
    justify-content: center;
    display: flex;
    cursor: not-allowed;
    padding-top: 4px;
    width: 64px;
  }
}

.avatar-uploader {
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 318px;
    height: 226px;
    line-height: 200px;
    text-align: center;
  }
  img {
    border: 1px solid #dedede;
    border-radius: 6px;
    cursor: pointer;
  }
  i {
    border: 1px solid #dedede;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
    }
  }
  .avatar-title {
    position: absolute;
    left: 96px;
    top: 120px;
    text-align: center;
    line-height: 24px;
  }
}
</style>

<style scoped>
.el-form-item >>> .el-form-item__label {
  line-height: 50px;
}

.payment-info >>> input {
  width: 100%;
  background-color: #fff;
}

.input-3 >>> .el-input__suffix {
  margin-right: 10px;
}

#register >>> .el-input__inner {
  /* background-color: #f9f9f9; */
  height: 50px;
}
#register >>> .el-form-item {
  margin-bottom: 6px !important;
}
#register >>> .el-form-item__error {
  color: #f56c6c;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 0px;
  right: 30px;
  left: initial;
}

.input-3 + .el-form-item__error {
  margin-right: 120px;
}

#verifyCode >>> .el-form-item__error {
  right: 146px;
}

#form-BusinessLicense >>> .el-form-item__error {
  top: 40px;
  right: 0;
  left: 334px;
}

#form-PicZzzm >>> .el-form-item__error {
  top: 40px;
  right: 0;
  left: 334px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/register.vue